import * as React from "react";
import { Link } from "react-router-dom";
import { DropdownItem } from 'reactstrap';

class FamilyPlanUsers extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { list, onUserSelected } = this.props;
        return (
            <div className="proxy-dropdown__health">
                {list && list.length > 0 &&
                    <div>
                        <DropdownItem header>Family Insurance Plan Accounts</DropdownItem>
                        {list.map((user, index) =>
                            <Link key={index} to={{ pathname: "/claims" }}>
                                <DropdownItem key={index} onClick={() => onUserSelected(user, index)}>
                                    {user.familyMember}
                                </DropdownItem>
                            </Link>
                        )}
                    </div>
                }
            </div>
        );
    }
}
export default FamilyPlanUsers;